var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMydriverOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "22px",
    viewBox: "0 0 16 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Drivers-(1)",
    transform: "translate(-24.000000, -565.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_mydriver",
    transform: "translate(20.000000, 444.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(5.500000, 2.000000)",
    stroke: "#FF5F00",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "12.5377778 19.18 6.36222222 19.18 0.186666667 19.18 0.42 14 12.32 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.92444444,6.18666667 L0.777777778,3.07555556 C0.777777778,3.07555556 4.51111111,0.275555556 6.36222222,0.275555556 C8.21333333,0.275555556 11.9466667,3.07555556 11.9466667,3.07555556 L9.8,6.18666667 L9.8,7.89777778 C9.8,9.79641002 8.26085446,11.3355556 6.36222222,11.3355556 C4.46358998,11.3355556 2.92444444,9.79641002 2.92444444,7.89777778 L2.92444444,6.18666667 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.92444444,6.18666667 L9.8,6.18666667",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36222222,14 L6.36222222,16.7844444",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMydriverOrange);
export default __webpack_public_path__ + "static/media/ico_mydriver_orange.bd00504f061430ce9af5288e0e1f574d.svg";
export { ForwardRef as ReactComponent };